const STORAGE_KEY = "lasertopo.compare.products";
let compareCheckboxUpdateHandler = null;
let floatingUpdateHandler = null;
let compareChangeBound = false;

function getStoredIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw)
      .map((id) => parseInt(id, 10))
      .filter((id) => Number.isFinite(id));
  } catch (error) {
    console.warn("Unable to read compare products", error);
    return [];
  }
}

function saveIds(ids) {
  try {
    const unique = Array.from(new Set(ids.filter((id) => Number.isFinite(id))));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    document.dispatchEvent(
      new CustomEvent("compare:change", { detail: { ids: unique } })
    );
  } catch (error) {
    console.warn("Unable to persist compare products", error);
  }
}

function getCompareBaseUrl() {
  const floating = document.querySelector("[data-compare-floating]");
  return floating ? floating.dataset.baseUrl || "/product-vergelijker" : "/product-vergelijker";
}

function bindCompareCheckboxes() {
  const updateState = () => {
    const saved = getStoredIds();
    document.querySelectorAll("[data-compare-checkbox]").forEach((checkbox) => {
      const id = parseInt(checkbox.dataset.productId, 10);
      checkbox.checked = saved.includes(id);
    });
    const compareHref = saved.length
      ? buildCompareUrl(getCompareBaseUrl(), "ids", saved)
      : "#";
    const singular = document.querySelector("[data-compare-floating]")?.dataset.labelSingular || "product";
    const plural = document.querySelector("[data-compare-floating]")?.dataset.labelPlural || "producten";
    document.querySelectorAll("[data-compare-go]").forEach((link) => {
      const id = parseInt(link.dataset.productId, 10);
      if (saved.includes(id)) {
        link.classList.remove("hidden!");
        link.setAttribute("href", compareHref);
        const countEl = link.querySelector("[data-compare-go-count]");
        const labelEl = link.querySelector("[data-compare-go-label]");
        if (countEl) countEl.textContent = saved.length;
        if (labelEl) labelEl.textContent = saved.length === 1 ? singular : plural;
      } else {
        link.classList.add("hidden!");
      }
    });
  };

  if (compareCheckboxUpdateHandler) {
    document.removeEventListener(
      "compare:change",
      compareCheckboxUpdateHandler
    );
  }
  compareCheckboxUpdateHandler = updateState;

  updateState();
  document.addEventListener("compare:change", updateState);

  if (!compareChangeBound) {
    document.addEventListener("change", (event) => {
      const checkbox = event.target.closest("[data-compare-checkbox]");
      if (!checkbox) return;
      const id = parseInt(checkbox.dataset.productId, 10);
      const current = getStoredIds();
      let next;
      if (checkbox.checked) {
        next = current.includes(id) ? current : [...current, id];
      } else {
        next = current.filter((stored) => stored !== id);
      }
      saveIds(next);
      updateState();
    });
    compareChangeBound = true;
  }
}

function buildCompareUrl(baseUrl, param, ids) {
  try {
    const url = new URL(baseUrl, window.location.origin);
    const params = new URLSearchParams(url.search);
    params.delete(param);
    if (ids.length) {
      params.set(param, ids.join(","));
    }
    let query = params.toString();
    if (query.includes("%2C") || query.includes("%2c")) {
      query = query.replace(/%2C/gi, ",");
    }
    return url.origin + url.pathname + (query ? `?${query}` : "");
  } catch (error) {
    console.warn("Unable to build compare url", error);
    return window.location.href;
  }
}

function initComparePage() {
  const root = document.querySelector("[data-compare-root]");
  if (!root) return;

  const baseUrl = root.dataset.baseUrl || window.location.href.split("?")[0];
  const param = root.dataset.param || "ids";
  const initialIds = (root.dataset.initialIds || "")
    .split(",")
    .map((id) => parseInt(id, 10))
    .filter((id) => Number.isFinite(id));
  const storedIds = getStoredIds();

  const cleanHref = window.location.href.replace(/%2C/gi, ",");
  if (cleanHref !== window.location.href) {
    window.history.replaceState({}, "", cleanHref);
  }

  if (!initialIds.length && storedIds.length) {
    window.location.href = buildCompareUrl(baseUrl, param, storedIds);
    return;
  }

  const refresh = (ids) => {
    window.location.href = buildCompareUrl(baseUrl, param, ids);
  };

  root.querySelectorAll("[data-remove-product]").forEach((button) => {
    button.addEventListener("click", () => {
      const id = parseInt(button.dataset.removeProduct, 10);
      const current = getStoredIds().filter((stored) => stored !== id);
      saveIds(current);
      refresh(current);
    });
  });

  root.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-compare-toggle]");
    if (!trigger) return;

    const key = trigger.getAttribute("data-compare-toggle");
    const expanded = trigger.getAttribute("aria-expanded") === "true";
    const nextState = !expanded;

    root.querySelectorAll(`[data-compare-toggle="${key}"]`).forEach((btn) => {
      btn.setAttribute("aria-expanded", nextState ? "true" : "false");
    });

    root.querySelectorAll(`[data-compare-panel="${key}"]`).forEach((panel) => {
      panel.classList.toggle("hidden", !nextState);
    });

    root
      .querySelectorAll(`[data-compare-toggle="${key}"] [data-chevron]`)
      .forEach((chevron) => {
        chevron.classList.toggle("rotate-90", nextState);
        chevron.classList.toggle("-rotate-0", !nextState);
      });
  });

  const scrollArea = root.querySelector("[data-compare-scroll-area]");
  const scrollButtons = root.querySelectorAll("[data-compare-scroll-btn]");
  const toggleColumnVisibility = (index, hidden) => {
    root
      .querySelectorAll(`[data-compare-column-index="${index}"]`)
      .forEach((el) => {
        el.classList.toggle("opacity-0", hidden);
      });
  };

  if (scrollArea) {
    const productColumns = Array.from(
      scrollArea.querySelectorAll("[data-compare-product-column]")
    );
    const labelCells = Array.from(
      root.querySelectorAll("[data-compare-label-cell]")
    );

    const updateDesktopScrollState = () => {
      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      const labelCell = root.querySelector("[data-compare-label-cell]");
      const labelWidth = isDesktop ? labelCell?.offsetWidth || 0 : 0;
      const scrollRect = scrollArea.getBoundingClientRect();
      const offset = scrollArea.scrollLeft;
      labelCells.forEach((cell) => {
        if (isDesktop) {
          cell.style.transform = `translateX(${offset}px)`;
        } else {
          cell.style.transform = "";
        }
      });

      productColumns.forEach((column) => {
        const index = parseInt(column.dataset.compareColumnIndex, 10) || 0;
        if (!isDesktop) {
          toggleColumnVisibility(index, false);
          return;
        }
        const rect = column.getBoundingClientRect();
        const overlapsLabel = rect.left < scrollRect.left + labelWidth;
        toggleColumnVisibility(index, overlapsLabel);
      });
    };

    scrollArea.addEventListener("scroll", updateDesktopScrollState);
    window.addEventListener("resize", updateDesktopScrollState);
    updateDesktopScrollState();
  }

  if (scrollArea && scrollButtons.length) {
    const getColumnWidth = () => 300;

    const scrollByColumn = (direction) => {
      const distance = getColumnWidth() * direction;
      scrollArea.scrollBy({ left: distance, behavior: "smooth" });
    };

    scrollButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const direction = parseInt(button.dataset.scrollDirection, 10) || 1;
        scrollByColumn(direction);
      });
    });
  }
}

function initFloatingCompareButton() {
  const floating = document.querySelector("[data-compare-floating]");
  if (floatingUpdateHandler) {
    document.removeEventListener("compare:change", floatingUpdateHandler);
    floatingUpdateHandler = null;
  }
  if (!floating) return;

  const path = window.location.pathname.toLowerCase();
  const baseUrl = floating.dataset.baseUrl || "/product-vergelijker";
  const param = floating.dataset.param || "ids";
  const singular = floating.dataset.labelSingular || "product";
  const plural = floating.dataset.labelPlural || "producten";
  const countEl = floating.querySelector("[data-compare-count]");
  const labelEl = floating.querySelector("[data-compare-label]");
  const linkEl = floating.querySelector("[data-floating-link]");

  const update = () => {
    const onValidPage = path.includes("producten") || path.includes("produits");
    if (!onValidPage) {
      floating.classList.add("hidden");
      floating.classList.remove("is-visible");
      return;
    }
    floating.classList.remove("hidden");
    const ids = getStoredIds();
    if (ids.length) {
      if (countEl) countEl.textContent = ids.length;
      if (labelEl) labelEl.textContent = ids.length === 1 ? singular : plural;
      if (linkEl) {
        linkEl.setAttribute("href", buildCompareUrl(baseUrl, param, ids));
      }
      floating.classList.add("is-visible");
    } else {
      floating.classList.remove("is-visible");
      floating.classList.add("hidden");
    }
  };

  update();
  floatingUpdateHandler = update;
  document.addEventListener("compare:change", update);
}

document.addEventListener("DOMContentLoaded", () => {
  bindCompareCheckboxes();
  initComparePage();
  initFloatingCompareButton();
});

document.addEventListener("sprig:end", () => {
  bindCompareCheckboxes();
  initFloatingCompareButton();
});
